import { Component, h } from 'preact';
import cx from 'classnames';

import { HopplerDatePicker } from './hoppler-date-picker.component';
import moment from 'moment';
import { Formats } from '../../../../constants';
import { DummyInputEvent } from '../../../utils/dummy-input-event';

interface DatePickerControlProps {
  forceFallbackInput?: boolean;

  type?: 'date';
  className?: string;
  class?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;

  name?: string;
  min?: string;
  max?: string;

  'aria-label'?: string;

  onChange?: (event: Event) => void;
}

export class DatePickerControl extends Component<DatePickerControlProps> {
  /**
   * Checks if the browser supports <input type="date">. Code based on:
   * https://stackoverflow.com/a/10199306/1626897
   */
  isNativeInputDateSupported() {
    const input = document.createElement('input');
    input.setAttribute('type','date');

    const notADateValue = 'not-a-date';
    input.setAttribute('value', notADateValue); 

    return (input.value !== notADateValue);
  }

  onFallbackValueChange(value) {
    // To fully emulate a native date input, we must use its date format. See:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/date
    const parsed = moment(value, Formats.date);
    const nativeInputFormattedDate = parsed.format('YYYY-MM-DD');

    if (this.props.onChange) {
      this.props.onChange(DummyInputEvent.createWithValue(nativeInputFormattedDate));
    }
  }

  getFallbackDatePicker(props: DatePickerControlProps) {
    return (
      <HopplerDatePicker initialValue={ props.value }
        onDateSelected={ date => this.onFallbackValueChange(date) }
        className={ props.className || props.class }
        isValid={ true }
        disabled={ props.disabled }
        
        min={ props.min } />
        // HopplerDatePicker does not support the "max" attribute
    );
  }

  render(props: DatePickerControlProps) {
    if (this.isNativeInputDateSupported() && !props.forceFallbackInput) {
      return (
        <input type="date"
          className={ cx('hi-datepickerctrl--native', props.className || props.class) }
          onChange={ props.onChange }
          value={ props.value }
          disabled={ props.disabled }

          name={ props.name }
          min={ props.min }
          max={ props.max }
          
          aria-label={ props['aria-label'] }/>
      );
    } else {
      return this.getFallbackDatePicker(props);
    }
  }
}
